import cn from 'clsx';
import type { CSSProperties, FC } from 'react';

import css from './HStack.module.css';

/**
 * Компонент для отображения элементов по вертикали с возможностью указать расстояние между элементами
 */
export const HStack: FC<THStackProps> = ({ gap, className, children }) => {
  const style = { '--h-stack-gap': `${gap}px` } as CSSProperties;

  return (
    <div className={cn(css.stack, className)} style={style}>
      {children}
    </div>
  );
};

export type THStackProps = {
  className?: string;
  gap?: number;
};
